import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLayoutTabs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 6C2.25 4.48122 3.48122 3.25 5 3.25H12C13.5188 3.25 14.75 4.48122 14.75 6V8C14.75 9.51878 13.5188 10.75 12 10.75H5C3.48122 10.75 2.25 9.51878 2.25 8V6ZM5 4.75C4.30964 4.75 3.75 5.30964 3.75 6V8C3.75 8.69036 4.30964 9.25 5 9.25H12C12.6904 9.25 13.25 8.69036 13.25 8V6C13.25 5.30964 12.6904 4.75 12 4.75H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.65 16.7499C9.42909 16.7499 9.25 16.929 9.25 17.15V17.9999C9.25 19.5187 10.4812 20.75 12 20.75H19C20.5188 20.75 21.75 19.5187 21.75 17.9999V15.9999C21.75 14.7025 20.8516 13.615 19.6429 13.3255C19.4253 13.2734 19.2307 13.4442 19.1913 13.6645C19.1524 13.8819 19.0948 14.0928 19.0202 14.2956C18.9421 14.5076 19.092 14.7551 19.3094 14.8168C19.8376 14.9668 20.25 15.3673 20.25 15.9999V17.9999C20.25 18.6903 19.6904 19.2499 19 19.2499H12C11.3096 19.2499 10.75 18.6903 10.75 17.9999V17.15C10.75 16.929 10.5709 16.7499 10.35 16.7499H9.65Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 12.15C5.75 11.929 5.92909 11.7499 6.15 11.7499H6.85C7.07091 11.7499 7.25 11.929 7.25 12.15V12.9999C7.25 13.6903 7.80964 14.2499 8.5 14.2499H15.5C16.1904 14.2499 16.75 13.6903 16.75 12.9999V10.9999C16.75 10.3673 16.3376 9.96679 15.8094 9.8168C15.592 9.75507 15.4421 9.50764 15.5202 9.29556C15.5948 9.09284 15.6524 8.8819 15.6913 8.66446C15.7307 8.4442 15.9253 8.27339 16.1429 8.32551C17.3516 8.61499 18.25 9.70255 18.25 10.9999V12.9999C18.25 14.5187 17.0188 15.7499 15.5 15.7499H8.5C6.98122 15.7499 5.75 14.5187 5.75 12.9999V12.15Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLayoutTabs as ReactComponent };
